function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M77 46C75.9 46 75 45.1 75 44 75 42.9 75.9 42 77 42 78.1 42 79 42.9 79 44 79 45.1 78.1 46 77 46ZM60 34C57.6 34 55 34.2 52.4 34.6L38 27C38 27 38.1 32.8 40.2 37.2 31.6 39.4 23.5 42 18 42L4 34C4 39.5 7 48 7 48 7 48 4 56.5 4 62L18 54C23.5 54 31.6 56.6 40.2 58.8 38.1 63.2 38 69 38 69L52.4 61.4C55 61.8 57.6 62 60 62 72.7 62 92 52.5 92 48 92 43.5 72.7 34 60 34Z",
  fill: "currentColor"
});

var SvgFish = function SvgFish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Fish",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fish.baf7938e.svg";
export { ForwardRef as ReactComponent };